'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var styles$g = require('./styles-7e762207.js');

var ItemQuantityBlock = function (_a) {
    var title = _a.title, subtitle = _a.subtitle, price = _a.price, additionalPrice = _a.additionalPrice, quantity = _a.quantity, _b = _a.dataCy, dataCy = _b === void 0 ? 'itemQuantityBlock' : _b, _c = _a.dataTestId, dataTestId = _c === void 0 ? 'itemQuantityBlock' : _c, className = _a.className;
    return (React__default.createElement(styles$g.ItemContainer, { className: className, "data-cy": dataCy, "data-testid": dataTestId },
        quantity && (React__default.createElement(styles$g.QuantityContainer, { "data-cy": dataCy + "-quantity", "data-testid": dataTestId + "-quantity" }, quantity)),
        React__default.createElement(styles$g.TextContainer, { className: "text-container" },
            React__default.createElement(styles$g.TitleText, { "data-cy": dataCy + "-title", "data-testid": dataTestId + "-title" }, title),
            subtitle && (React__default.createElement(styles$g.SubtitleText, { className: "subtitle-text", "data-cy": dataCy + "-subtitle", "data-testid": dataTestId + "-subtitle" }, subtitle))),
        React__default.createElement(styles$g.PriceContainer, null,
            React__default.createElement(styles$g.Price, { "data-cy": dataCy + "-price", "data-testid": dataTestId + "-price" }, price),
            additionalPrice && (React__default.createElement(styles$g.SubtitleText, { className: "additional-price", "data-cy": dataCy + "-additional-price", "data-testid": dataTestId + "-additional-price" }, additionalPrice)))));
};

exports.ItemQuantityBlock = ItemQuantityBlock;
